import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"

import { invalidateVendor, invalidateVendorLists, invalidateVendors } from "Shared/queries/vendors/vendor.queries"
import { isClientErrorCode } from "Shared/utils/errorHandler.utils"
import { Dispatch } from "redux"

export const subscribeToVendor = async (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data
    try {
        switch (operationType) {
            case OperationTypeEnum.INSERT:
            case OperationTypeEnum.UPDATE:
                await invalidateVendorLists()
                await invalidateVendors()
                break
            case OperationTypeEnum.DELETE:
                await invalidateVendorLists()
                break
            case OperationTypeEnum.BULK_UPDATE:
                await invalidateVendorLists()
                await invalidateVendors()
                break
            case OperationTypeEnum.UPDATE_COMMENT:
            case OperationTypeEnum.INSERT_COMMENT:
            case OperationTypeEnum.DELETE_COMMENT:
                await invalidateVendor(documentId?.toString())
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Vendor Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}

export const subscribeToVendorCallbacks = async (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data
    try {
        switch (operationType) {
            case OperationTypeEnum.BULK_UPDATE:
                await invalidateVendorLists()
                await invalidateVendors()
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Vendor Socket Callbacks] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
